import AbstractRepository from "@/repositories/AbstractRepository";

export default class GroupCommitmentRepository extends AbstractRepository {
    protected static resource: string = "ptf-budget-groupcommitment";

    protected static defaultFields: string[] = [
        "uuid",
        "label",
        "type",
        "amount",
        "amountIncludingTax",
        "parent.uuid",
        "budget.uuid",
    ];
}
